import {
    h, ComponentChildren, JSX, Ref
} from "preact";

import classname from "../../../foundation/utils/classname";
import IconArrowDown from "../../v2/Icons/IconArrowDown";

import styles from "./WidgetButton.module.css";

type NativeButtonProps = Omit<JSX.HTMLAttributes<HTMLButtonElement>, "icon">;

interface Props extends NativeButtonProps {
    buttonRef?: Ref<HTMLButtonElement>;
    minimized?: boolean;
    activated?: boolean;
    pressed?: boolean;
    shortcut?: ComponentChildren;
    icon?: ComponentChildren;
    label?: string;
    showChevron?: boolean;
}

export default function WidgetButton({
    class: cssClass,
    buttonRef,
    activated,
    pressed,
    minimized,
    shortcut,
    icon: Icon,
    label,
    showChevron = false,
    ...nativeButtonProps
}: Props) {
    const hasShortcut = !!shortcut;
    const onlyIcon = minimized && !!Icon && !showChevron;

    return (
        <button
            {...nativeButtonProps}
            ref={buttonRef}
            className={classname(styles.widgetButton, "body-1", cssClass, {
                [styles.activated]: activated,
                [styles.hasShortcut]: hasShortcut,
                [styles.minimized]: minimized,
                [styles.onlyIcon]: onlyIcon,
                [styles.pressed]: pressed
            })}>
            {Icon && (
                <div className={styles.icon}>
                    {Icon}
                </div>
            )}
            {!minimized && label && <span className={styles.content}>{label}</span>}
            {shortcut && <div className={styles.shortcut}>{shortcut}</div>}
            {showChevron && <IconArrowDown class={styles.chevron}/>}
        </button>
    );
}

export {
    Props as WidgetButtonProps
};
